import type { SVGProps } from 'react'
const SvgBookmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    viewBox="0 0 16 17"
    {...props}
  >
    <path d="m13.27 15.73-5.104-4.61a.24.24 0 0 0-.332 0l-5.09 4.61a1.03 1.03 0 0 1-1.127.17 1.06 1.06 0 0 1-.45-.4A1.1 1.1 0 0 1 1 14.916V3.29c-.002-.301.055-.6.166-.879a2.3 2.3 0 0 1 .484-.745c.208-.213.455-.381.727-.496s.564-.172.858-.17h9.545c.293 0 .582.06.853.175.27.115.515.284.722.497.206.212.37.465.48.743s.167.575.165.875v11.656a1.1 1.1 0 0 1-.17.575c-.11.17-.266.306-.449.388a1.015 1.015 0 0 1-1.111-.18" />
  </svg>
)
export default SvgBookmark
